var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9167 23.7083H24.2083V3.29167H3.79167V23.7083H14V16.4167H11.0833V13.5H14V11.0879C14 9.13812 14.2042 8.43083 14.5833 7.71771C14.9568 7.01215 15.5341 6.43538 16.24 6.0625C16.7971 5.76354 17.4898 5.58417 18.7002 5.50688C19.18 5.47625 19.8013 5.51417 20.564 5.62354V8.39437H19.8333C18.496 8.39437 17.9433 8.45708 17.6138 8.63354C17.4171 8.73469 17.257 8.8948 17.1558 9.09146C16.9808 9.42104 16.9167 9.74771 16.9167 11.0865V13.5H20.5625L19.8333 16.4167H16.9167V23.7083ZM2.33333 0.375H25.6667C26.0534 0.375 26.4244 0.528645 26.6979 0.802136C26.9714 1.07563 27.125 1.44656 27.125 1.83333V25.1667C27.125 25.5534 26.9714 25.9244 26.6979 26.1979C26.4244 26.4714 26.0534 26.625 25.6667 26.625H2.33333C1.94656 26.625 1.57563 26.4714 1.30214 26.1979C1.02865 25.9244 0.875 25.5534 0.875 25.1667V1.83333C0.875 1.44656 1.02865 1.07563 1.30214 0.802136C1.57563 0.528645 1.94656 0.375 2.33333 0.375Z",
    fill: "#8DAA6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookImage);
export default __webpack_public_path__ + "static/media/facebook-image.c8bf80b12fa63ad16278e498ee4539ad.svg";
export { ForwardRef as ReactComponent };